export const alphabets = {
  latin: 'latin',
  cyrillic: 'cyrillic'
}

export const supportTypes = {
  phones: 'phones',
  emails: 'emails',
  websites: 'websites',
  socials: 'socials'
}

export const displays = {
  desktop: 'desktop',
  mobile: 'mobile'
}
